// src/pages/Orders.js
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { PackagePlus } from "lucide-react";
import api from "../services/api";

const Orders = () => {
  const token = localStorage.getItem("token");
  const [products, setProducts] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetchProducts();
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const fetchProducts = async () => {
    try {
      const res = await api.get(`/products-search/key?product_type=others`, {
        headers: { Authorization: token },
      });
      setProducts(res.data.data);
    } catch {
      Swal.fire("Error", "Gagal memuat data produk", "error");
    }
  };

  const fetchInvoices = async () => {
    let url = "/my-invoice";
    if (filter !== "all") url += `?status=${filter}`;
    try {
      const res = await api.get(url, {
        headers: { Authorization: token },
      });
      setInvoices(res.data);
    } catch {
      Swal.fire("Error", "Gagal memuat invoice", "error");
    }
  };

  const handleQuantityChange = (productId, quantity) => {
    setSelectedItems((prev) => {
      const existing = prev.find((item) => item.product_id === productId);
      if (existing) {
        return prev.map((item) =>
          item.product_id === productId
            ? { ...item, quantity: parseInt(quantity) }
            : item
        );
      } else {
        return [
          ...prev,
          { product_id: productId, quantity: parseInt(quantity) },
        ];
      }
    });
  };

  const printReceipt = (invoiceId, amountPaid, vouchers) => {
    const dateStr = new Date().toLocaleString();

    const voucherRows = vouchers
      .map(
        ([, username, password, profile]) =>
          `<tr><td>${username}</td><td>${password}</td><td>${profile}</td></tr>`
      )
      .join("");

    const receiptWindow = window.open("", "PRINT", "width=300,height=600");

    receiptWindow.document.write(`
      <html>
      <head>
        <title>Struk Pembayaran</title>
        <style>
          body { font-family: monospace; font-size: 12px; padding: 10px; width: 250px; }
          h2, p { text-align: center; margin: 4px 0; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { padding: 4px; text-align: left; border-bottom: 1px dashed #ccc; }
          .center { text-align: center; }
          .bold { font-weight: bold; }
          hr { border: none; border-top: 1px dashed #000; margin: 10px 0; }
        </style>
      </head>
      <body>
        <h2>STRUK PEMBAYARAN</h2>
        <p>Tanggal: ${dateStr}</p>
        <p>Invoice ID: ${invoiceId}</p>
        <hr />
        <p class="bold">Voucher:</p>
        <table>
          <thead>
            <tr><th>User</th><th>Pass</th><th>Profile</th></tr>
          </thead>
          <tbody>
            ${voucherRows}
          </tbody>
        </table>
        <hr />
        <p class="center bold">Total Bayar: Rp ${parseInt(
          amountPaid
        ).toLocaleString()}</p>
        <p class="center">Terima kasih 🙏</p>
        <script>window.print(); setTimeout(() => { window.close(); }, 1000);</script>
      </body>
      </html>
    `);

    receiptWindow.document.close();
    receiptWindow.focus();
  };

  const handleCreateOrder = async () => {
    const items = selectedItems.filter((item) => item.quantity > 0);
    if (items.length === 0) {
      return Swal.fire("Error", "Pilih produk dan jumlahnya", "error");
    }

    try {
      const res = await api.post(
        `/orders`, // ← sesuai endpoint baru
        { user_id: 1, items }, // ← sesuai format yang lo kasih
        { headers: { Authorization: token } }
      );
      Swal.fire("Berhasil", res.data.message, "success");
      fetchInvoices();
    } catch {
      Swal.fire("Error", "Gagal membuat order", "error");
    }
  };

  const handleCheckout = async (invoiceId) => {
    console.log(invoiceId);
    try {
      const res = await api.post(
        `/checkout`,
        { invoice_id: invoiceId },
        { headers: { Authorization: token } }
      );
      const { message, invoice_id, amount_paid, vouchers } = res.data;

      console.log("Respon checkout:", res);

      const voucherRows = vouchers
        .map(
          ({ username, password, profile }) =>
            `<tr><td>${username}</td><td>${password}</td><td>${profile}</td></tr>`
        )
        .join("");

      console.log("Vouchers from checkout:", vouchers);

      Swal.fire({
        title: "Checkout Berhasil!",
        html: `
          <p>${message}</p>
          <p><strong>Jumlah Dibayar:</strong> Rp ${parseInt(
            amount_paid
          ).toLocaleString()}</p>
          <p><strong>Voucher:</strong></p>
          <ul style="text-align: left;">${voucherRows}</ul>
        `,
        icon: "success",
        confirmButtonText: "Tutup",
      }).then(() => {
        printReceipt(invoice_id, amount_paid, vouchers);
      });

      fetchInvoices();
    } catch {
      Swal.fire("Error", "Checkout gagal", "error");
    }
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <PackagePlus /> Regular Products
        </h1>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-gray-100 dark:bg-gray-800 border rounded p-4 shadow-sm"
          >
            <h2 className="font-semibold text-lg">{product.name}</h2>
            <p className="text-sm text-gray-500">{product.description}</p>
            <p className="text-sm mb-2">
              Rp {parseInt(product.price).toLocaleString()}
            </p>
            <input
              type="number"
              min="0"
              placeholder="Jumlah"
              className="w-full border text-black dark:text-white border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
              onChange={(e) => handleQuantityChange(product.id, e.target.value)}
            />
          </div>
        ))}
      </div>
      <button
        onClick={handleCreateOrder}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
      >
        Buat Order
      </button>

      <div className="mt-10">
        <h1 className="text-2xl font-bold mb-4">Invoice Saya</h1>
        <div className="flex gap-4 mb-4">
          <button
            onClick={() => setFilter("all")}
            className={`px-4 py-2 rounded text-black dark:text-white ${
              filter === "all" ? "bg-blue-600" : "bg-gray-200"
            }`}
          >
            Semua
          </button>
          <button
            onClick={() => setFilter("paid")}
            className={`px-4 py-2 rounded text-black dark:text-white ${
              filter === "paid" ? "bg-green-600" : "bg-gray-200"
            }`}
          >
            Lunas
          </button>
          <button
            onClick={() => setFilter("unpaid")}
            className={`px-4 py-2 rounded text-black dark:text-white ${
              filter === "unpaid" ? "bg-red-600" : "bg-gray-200"
            }`}
          >
            Belum Lunas
          </button>
        </div>

        <div className="space-y-4">
          {invoices.length === 0 && <p>Tidak ada invoice.</p>}
          {invoices.map((inv) => (
            <div key={inv.id} className="border rounded p-4 shadow">
              <p>
                <strong>ID:</strong> {inv.id}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span
                  className={`font-semibold ${
                    inv.status === "paid" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {inv.status}
                </span>
              </p>
              <p>
                <strong>Total:</strong> Rp{" "}
                {parseInt(inv.total_amount).toLocaleString()}
              </p>
              <p>
                <strong>Dibuat:</strong>{" "}
                {new Date(inv.issued_at).toLocaleString()}
              </p>
              {inv.paid_at && (
                <p>
                  <strong>Dibayar:</strong>{" "}
                  {new Date(inv.paid_at).toLocaleString()}
                </p>
              )}
              <div className="mt-2">
                <strong>Item:</strong>
                <ul className="list-disc ml-5">
                  {inv.items.map((item, idx) => (
                    <li key={idx}>
                      {item.product_name} ({item.product_type}) ×{" "}
                      {item.quantity} — Rp{" "}
                      {parseInt(item.price).toLocaleString()} :{" "}
                    </li>
                  ))}
                </ul>
              </div>
              {inv.status !== "paid" && (
                <button
                  onClick={() => handleCheckout(inv.id)}
                  className="mt-3 bg-green-600 text-white px-3 py-1 rounded"
                >
                  Bayar Pakai Saldo
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Orders;
